__turbopack_context__.v({
  "accent": "home-page-module__29Nb3W__accent",
  "cardIcon": "home-page-module__29Nb3W__cardIcon",
  "cardImage": "home-page-module__29Nb3W__cardImage",
  "carouselButton": "home-page-module__29Nb3W__carouselButton",
  "carouselControl": "home-page-module__29Nb3W__carouselControl",
  "carouselControls": "home-page-module__29Nb3W__carouselControls",
  "carouselSlide": "home-page-module__29Nb3W__carouselSlide",
  "carouselTrack": "home-page-module__29Nb3W__carouselTrack",
  "carouselViewport": "home-page-module__29Nb3W__carouselViewport",
  "challengeColumnTitle": "home-page-module__29Nb3W__challengeColumnTitle",
  "challengeColumns": "home-page-module__29Nb3W__challengeColumns",
  "challengeList": "home-page-module__29Nb3W__challengeList",
  "challenges": "home-page-module__29Nb3W__challenges",
  "challengesCopy": "home-page-module__29Nb3W__challengesCopy",
  "challengesImage": "home-page-module__29Nb3W__challengesImage",
  "challengesInner": "home-page-module__29Nb3W__challengesInner",
  "chevron": "home-page-module__29Nb3W__chevron",
  "chevronEyebrow": "home-page-module__29Nb3W__chevronEyebrow",
  "chevronIntro": "home-page-module__29Nb3W__chevronIntro",
  "compliance": "home-page-module__29Nb3W__compliance",
  "complianceCard": "home-page-module__29Nb3W__complianceCard",
  "complianceCards": "home-page-module__29Nb3W__complianceCards",
  "complianceCopy": "home-page-module__29Nb3W__complianceCopy",
  "complianceInner": "home-page-module__29Nb3W__complianceInner",
  "eyebrow": "home-page-module__29Nb3W__eyebrow",
  "footerCta": "home-page-module__29Nb3W__footerCta",
  "footerCtaBody": "home-page-module__29Nb3W__footerCtaBody",
  "footerCtaButton": "home-page-module__29Nb3W__footerCtaButton",
  "footerCtaCopy": "home-page-module__29Nb3W__footerCtaCopy",
  "footerCtaIcon": "home-page-module__29Nb3W__footerCtaIcon",
  "footerCtaInner": "home-page-module__29Nb3W__footerCtaInner",
  "footerCtaText": "home-page-module__29Nb3W__footerCtaText",
  "footerCtaTitle": "home-page-module__29Nb3W__footerCtaTitle",
  "hero": "home-page-module__29Nb3W__hero",
  "heroBody": "home-page-module__29Nb3W__heroBody",
  "heroCopy": "home-page-module__29Nb3W__heroCopy",
  "heroInner": "home-page-module__29Nb3W__heroInner",
  "heroPattern": "home-page-module__29Nb3W__heroPattern",
  "heroTitle": "home-page-module__29Nb3W__heroTitle",
  "home": "home-page-module__29Nb3W__home",
  "imageRight": "home-page-module__29Nb3W__imageRight",
  "industryBody": "home-page-module__29Nb3W__industryBody",
  "industryCopy": "home-page-module__29Nb3W__industryCopy",
  "industryInner": "home-page-module__29Nb3W__industryInner",
  "industryLeaders": "home-page-module__29Nb3W__industryLeaders",
  "logoCard": "home-page-module__29Nb3W__logoCard",
  "logoGrid": "home-page-module__29Nb3W__logoGrid",
  "moveChevron": "home-page-module__29Nb3W__moveChevron",
  "primaryCta": "home-page-module__29Nb3W__primaryCta",
  "productBand": "home-page-module__29Nb3W__productBand",
  "productBandVideo": "home-page-module__29Nb3W__productBandVideo",
  "productBody": "home-page-module__29Nb3W__productBody",
  "productCopy": "home-page-module__29Nb3W__productCopy",
  "productCta": "home-page-module__29Nb3W__productCta",
  "productCtas": "home-page-module__29Nb3W__productCtas",
  "productMedia": "home-page-module__29Nb3W__productMedia",
  "productShowcase": "home-page-module__29Nb3W__productShowcase",
  "productTitle": "home-page-module__29Nb3W__productTitle",
  "productVideo": "home-page-module__29Nb3W__productVideo",
  "reviewLink": "home-page-module__29Nb3W__reviewLink",
  "sectionTitle": "home-page-module__29Nb3W__sectionTitle",
  "serviceCard": "home-page-module__29Nb3W__serviceCard",
  "serviceCarousel": "home-page-module__29Nb3W__serviceCarousel",
  "serviceSubtitle": "home-page-module__29Nb3W__serviceSubtitle",
  "serviceTitle": "home-page-module__29Nb3W__serviceTitle",
  "stars": "home-page-module__29Nb3W__stars",
  "uniqueAdvantages": "home-page-module__29Nb3W__uniqueAdvantages",
  "uniqueCopy": "home-page-module__29Nb3W__uniqueCopy",
  "uniqueImageWrap": "home-page-module__29Nb3W__uniqueImageWrap",
  "uniqueRow": "home-page-module__29Nb3W__uniqueRow",
  "uniqueRows": "home-page-module__29Nb3W__uniqueRows",
});
